import { Pipeline } from "@supernova-studio/model";
import { DTOPipeline } from "../../dto/export/pipeline";

export function pipelineToDto(pipeline: Pipeline): DTOPipeline {
  return {
    id: pipeline.id,
    name: pipeline.name,
    eventType: pipeline.eventType,
    isEnabled: pipeline.isEnabled,
    workspaceId: pipeline.workspaceId,
    designSystemId: pipeline.designSystemId,
    exporterId: pipeline.exporterId,
    brandPersistentId: pipeline.brandPersistentId,
    themePersistentId: pipeline.themePersistentId,
    themePersistentIds: pipeline.themePersistentIds,
    destinationAzure: pipeline.destinationAzure,
    destinationBitbucket: pipeline.destinationBitbucket,
    destinationSnDocs: pipeline.destinationSnDocs,
    destinationGithub: pipeline.destinationGithub,
    destinationGitlab: pipeline.destinationGitlab,
    destinationS3: pipeline.destinationS3,
    exporterPropertyValues: pipeline.exporterPropertyValues,
    webhookUrl: pipeline.webhookUrl,
    latestJobs: [],
    isExporterDeprecated: pipeline.isExporterDeprecated,
  };
}
